// @ts-nocheck
export function startswith(str: string, prefix: string): boolean {
  return str && str.indexOf(prefix) === 0
}
export function endswith(str: string, suffix: string): boolean {
  return str.indexOf(suffix, str.length - suffix.length) !== -1
}
